export default "__VITE_ASSET__CgUZRcwu__"